/* LIQUID_GOLD: Phase 1 — global chrome behaviour.
   Four modules registered through window.LiquidGold: announcement rotation,
   header scroll state, mega menu + mobile drawer, Find Us modal.
   No globals beyond window.LiquidGold. */

(function () {
  'use strict';

  var LG = window.LiquidGold;
  if (!LG) return; // core script failed to load; degrade to static chrome

  /* ===============================================================
     1. ANNOUNCEMENT BAR
     =============================================================== */

  LG.register(
    'announce',
    function (root) {
      var bars = (root || document).querySelectorAll('[data-lg-announce]:not([data-lg-ready])');

      Array.prototype.forEach.call(bars, function (bar) {
        bar.setAttribute('data-lg-ready', '');

        var msgs = bar.querySelectorAll('[data-lg-announce-msg]');
        var dots = bar.querySelectorAll('[data-lg-announce-dot]');
        var dismiss = bar.querySelector('[data-lg-announce-dismiss]');
        var storageKey = 'lg_announcement_dismissed_' + bar.getAttribute('data-lg-section-id');

        // LIQUID_GOLD: in the theme editor always show the bar, so the merchant
        // can style it even after dismissing it once on the storefront.
        var inEditor = bar.getAttribute('data-lg-editor') === 'true';
        if (!inEditor && dismiss && LG.storage.get(storageKey) === '1') {
          bar.hidden = true;
          return;
        }

        if (dismiss) {
          dismiss.addEventListener('click', function () {
            bar.hidden = true;
            LG.storage.set(storageKey, '1');
          });
        }

        if (msgs.length < 2) return; // nothing to rotate

        var index = 0;
        var timer = null;
        var seconds = parseInt(bar.getAttribute('data-lg-rotate-seconds'), 10) || 6;
        var auto = bar.getAttribute('data-lg-auto-rotate') === 'true';

        function show(next) {
          msgs[index].classList.remove('lg-announce__msg--active');
          if (dots[index]) dots[index].setAttribute('aria-current', 'false');
          index = (next + msgs.length) % msgs.length;
          msgs[index].classList.add('lg-announce__msg--active');
          if (dots[index]) dots[index].setAttribute('aria-current', 'true');
        }

        function start() {
          if (!auto || timer) return;
          timer = window.setInterval(function () {
            show(index + 1);
          }, seconds * 1000);
        }
        function stop() {
          window.clearInterval(timer);
          timer = null;
        }

        Array.prototype.forEach.call(dots, function (dot, i) {
          dot.addEventListener('click', function () {
            stop();
            show(i);
            start();
          });
        });

        bar.addEventListener('mouseenter', stop);
        bar.addEventListener('mouseleave', start);
        bar.addEventListener('focusin', stop);
        bar.addEventListener('focusout', start);

        bar._lgStop = stop;
        start();
      });
    },
    function (root) {
      var bars = (root || document).querySelectorAll('[data-lg-announce]');
      Array.prototype.forEach.call(bars, function (bar) {
        if (bar._lgStop) bar._lgStop();
      });
    }
  );

  /* ===============================================================
     2. HEADER SCROLL STATE
     =============================================================== */

  LG.register(
    'header',
    function (root) {
      var headers = (root || document).querySelectorAll('[data-lg-header]:not([data-lg-ready])');

      Array.prototype.forEach.call(headers, function (header) {
        header.setAttribute('data-lg-ready', '');

        var lastY = window.pageYOffset;
        var THRESHOLD = 200;

        header._lgUnsub = LG.onScroll(function () {
          var y = window.pageYOffset;

          header.classList.toggle('lg-header--scrolled', y > 10);

          // LIQUID_GOLD: never retract while a menu or drawer is open —
          // the panel is anchored to the header and would fly off-screen.
          if (header.getAttribute('data-lg-locked') === 'true') {
            header.classList.remove('lg-header--hidden');
          } else if (y > THRESHOLD && y > lastY) {
            header.classList.add('lg-header--hidden');
          } else {
            header.classList.remove('lg-header--hidden');
          }

          lastY = y;
        });
      });
    },
    function (root) {
      var headers = (root || document).querySelectorAll('[data-lg-header]');
      Array.prototype.forEach.call(headers, function (h) {
        if (h._lgUnsub) h._lgUnsub();
      });
    }
  );

  /* ===============================================================
     3. MEGA MENU + MOBILE DRAWER
     =============================================================== */

  /* LIQUID_GOLD: one delegated outside-click listener for every mega menu,
     attached once. Attaching it per-menu inside the loop leaked a listener on
     each theme-editor section reload, each holding a detached DOM reference. */
  var megaOutsideBound = false;

  function closeAllMegas(except) {
    var all = document.querySelectorAll('[data-lg-mega]');
    Array.prototype.forEach.call(all, function (mega) {
      if (mega === except) return;
      var panel = mega.querySelector('[data-lg-mega-panel]');
      var trigger = mega.querySelector('[data-lg-mega-trigger]');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var header = mega.closest('[data-lg-header]');
      if (header) header.setAttribute('data-lg-locked', 'false');
    });
  }

  function onDocumentClick(event) {
    var inside = event.target.closest ? event.target.closest('[data-lg-mega]') : null;
    closeAllMegas(inside);
  }

  LG.register('nav', function (root) {
    var scope = root || document;

    if (!megaOutsideBound) {
      document.addEventListener('click', onDocumentClick);
      megaOutsideBound = true;
    }

    /* ---- Mega menus (desktop) ---- */
    var megas = scope.querySelectorAll('[data-lg-mega]:not([data-lg-ready])');

    Array.prototype.forEach.call(megas, function (mega) {
      mega.setAttribute('data-lg-ready', '');

      var trigger = mega.querySelector('[data-lg-mega-trigger]');
      var panel = mega.querySelector('[data-lg-mega-panel]');
      var header = mega.closest('[data-lg-header]');
      if (!trigger || !panel) return;

      var openTimer = null;

      function setOpen(open) {
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (header) header.setAttribute('data-lg-locked', open ? 'true' : 'false');
      }

      trigger.addEventListener('click', function () {
        var willOpen = panel.hidden;
        closeAllMegas(mega);
        setOpen(willOpen);
      });

      // LIQUID_GOLD: 120ms intent delay so brushing past the trigger on the way
      // to another nav item does not flash the panel open.
      mega.addEventListener('mouseenter', function () {
        if (window.matchMedia('(max-width: 768px)').matches) return;
        openTimer = window.setTimeout(function () {
          closeAllMegas(mega);
          setOpen(true);
        }, 120);
      });
      mega.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
        setOpen(false);
      });

      mega.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          trigger.focus();
        }
      });
    });

    /* ---- Mobile drawer ---- */
    var drawers = scope.querySelectorAll('[data-lg-drawer]:not([data-lg-ready])');

    Array.prototype.forEach.call(drawers, function (drawer) {
      drawer.setAttribute('data-lg-ready', '');

      var id = drawer.getAttribute('data-lg-drawer');
      var openers = document.querySelectorAll('[data-lg-drawer-open="' + id + '"]');
      var closer = drawer.querySelector('[data-lg-drawer-close]');
      var release = null;

      function open() {
        drawer.hidden = false;
        LG.lockScroll();
        release = LG.trapFocus(drawer);
      }

      function close() {
        drawer.hidden = true;
        LG.unlockScroll();
        if (release) {
          release();
          release = null;
        }
      }

      Array.prototype.forEach.call(openers, function (btn) {
        btn.addEventListener('click', open);
      });
      if (closer) closer.addEventListener('click', close);

      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });

      // Any link inside navigates away — close so the drawer is not left open
      // behind the new page in a bfcache restore.
      Array.prototype.forEach.call(drawer.querySelectorAll('a[href]'), function (a) {
        a.addEventListener('click', close);
      });

      drawer._lgClose = close;
    });
  },
  function (root) {
    // LIQUID_GOLD: a drawer removed while open would otherwise leave the body
    // scroll-locked and focus trapped on a detached node.
    var drawers = (root || document).querySelectorAll('[data-lg-drawer]');
    Array.prototype.forEach.call(drawers, function (d) {
      if (d._lgClose && !d.hidden) d._lgClose();
    });
  });

  /* ===============================================================
     4. FIND US MODAL
     =============================================================== */

  LG.register('findus', function (root) {
    var modals = (root || document).querySelectorAll('[data-lg-findus]:not([data-lg-ready])');

    Array.prototype.forEach.call(modals, function (modal) {
      modal.setAttribute('data-lg-ready', '');

      var id = modal.getAttribute('data-lg-findus');
      var openers = document.querySelectorAll('[data-lg-findus-open="' + id + '"]');
      var closer = modal.querySelector('[data-lg-findus-close]');
      var frame = modal.querySelector('[data-lg-map]');
      var release = null;

      function open() {
        modal.hidden = false;
        // LIQUID_GOLD: inject the map src only on first open so the iframe
        // never costs page weight for visitors who never open it.
        if (frame && !frame.getAttribute('src')) {
          frame.setAttribute('src', frame.getAttribute('data-src'));
        }
        LG.lockScroll();
        release = LG.trapFocus(modal);
      }

      function close() {
        modal.hidden = true;
        LG.unlockScroll();
        if (release) {
          release();
          release = null;
        }
      }

      Array.prototype.forEach.call(openers, function (btn) {
        btn.addEventListener('click', open);
      });
      if (closer) closer.addEventListener('click', close);

      modal.addEventListener('click', function (event) {
        if (event.target === modal) close(); // backdrop click
      });
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });

      modal._lgClose = close;
    });
  },
  function (root) {
    // Same reasoning as the drawer teardown: never leave the page locked.
    var modals = (root || document).querySelectorAll('[data-lg-findus]');
    Array.prototype.forEach.call(modals, function (m) {
      if (m._lgClose && !m.hidden) m._lgClose();
    });
  });
})();
